import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useCallback, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { CertificateFormVM } from 'front-office/view-models/certificate/certificate-form';
import NotAireCheckboxes from './not-aire-checkboxes';
import AireCheckboxes from './aire-checkboxes';
import { historyCheckbox, isBlockingCheckbox } from 'front-office/constants/blocked-checkbox';
import { DateTime } from 'luxon';
import { ELETT, PPAA } from 'front-office/constants/payment-mode';

const CertificateAnprComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CertificateFormVM>();

  const onChange = useCallback(
    (identifier) => {
      const slicedElements = formContext.values.certificateAnpr?.slice() || [];

      const isSelected = !!slicedElements?.find(
        (identifierSelected) =>
          identifierSelected.key?.codiceDocumento === identifier.key?.codiceDocumento
      );

      if (isSelected) {
        const filteredList = slicedElements?.filter(
          (identifierSelected) =>
            identifierSelected.key?.codiceDocumento !== identifier.key?.codiceDocumento
        );
        formContext.setFieldValue('certificateAnpr', filteredList);
        return;
      }

      slicedElements.push(identifier);

      const filteredNotBlockedList = slicedElements?.filter((identifierSelected) => {
        if (
          !isBlockingCheckbox.includes(identifierSelected.key.codiceDocumento) &&
          isBlockingCheckbox.includes(identifier.key.codiceDocumento)
        ) {
          return false;
        }

        return true;
      });

      formContext.setFieldValue('certificateAnpr', filteredNotBlockedList);

      if (historyCheckbox.includes(identifier.key.codiceDocumento)) {
        formContext.setFieldValue('dateForm', null);
      } else {
        formContext.setFieldValue('dateForm', DateTime.now());
      }
    },
    [formContext.values.certificateAnpr, formContext.setFieldValue]
  );

  useEffect(() => {
    if (
      formContext.values.certificateAnpr?.some(
        (el) =>
          (el.key.codiceDocumento === '21' || el.key.codiceDocumento === '22') &&
          el.key.tipoDocumento === 'CA'
      )
    ) {
      formContext.setValues({
        ...(formContext.values || {}),
        typePayment: 'C',
        modality: formContext.values.certificateInternOnly ? ELETT : null,
      });
    } else {
      formContext.setValues({
        ...(formContext.values || {}),
        typePayment: 'C',
        modality: formContext.values.certificateInternOnly ? PPAA : null,
      });
    }
  }, [formContext.values.certificateAnpr]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificate-anpr-content"
        id="panel-certificate-anpr-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Certificati ANPR</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {formContext.values.accountholder?.isAire ||
        (formContext.values.isAire && formContext.values.accountholder?.sameApplicant) ? (
          <AireCheckboxes values={formContext.values.certificateAnpr} onChange={onChange} />
        ) : (
          <NotAireCheckboxes values={formContext.values.certificateAnpr} onChange={onChange} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

CertificateAnprComponent.displayName = 'Accordion certificate anpr component';

const CertificateAnpr = memo(CertificateAnprComponent);

export default CertificateAnpr;
